<template>
    <div class="famous-pedia-title-bar dsp-flex">
        <div class="famous-pedia-title-side">
            <div class="famous-pedia-title-side-box-l">
                <span class="famous-pedia-title-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></span>
                <!-- <span v-if="fromPage == 'FamousPediaRead'" class="famous-pedia-title-good" @click="clickGood"><i class="iconfont" v-bind:class="{'icon-good2': curPediaBaziLike, 'icon-good3': !curPediaBaziLike}"></i>{{curPediaBaziInfo.f_like}}</span> -->
                <span v-if="fromPage == 'FamousPediaRead'" class="famous-pedia-title-star" @click="clickStar"><i class="iconfont" v-bind:class="{'icon-star': !curPediaBaziCollect, 'icon-star-shi': curPediaBaziCollect}"></i></span>
                <button v-if="fromPage != 'FamousPediaEditWeb'" class="famous-pedia-title-button" @click="clickCreate"><span>创建</span></button>
            </div>
        </div>
        <div class="famous-pedia-title-mid">
            <span class="famous-pedia-title-name">{{titleName}}</span>
        </div>
        <div v-if="fromPage == 'FamousPediaRead'" class="famous-pedia-title-side">
            <div class="famous-pedia-title-side-box-r">
                <button class="famous-pedia-title-button-new" @click="clickEdit"><span>编辑</span></button>
                <button v-if="curPediaBaziInfoToBZ.canSave == 1" class="famous-pedia-title-button-new" @click="clickSave"><span>保存</span></button>
                <button class="famous-pedia-title-button-new" @click="clickInvite"><span>分享</span></button>
                <!-- <button class="famous-pedia-title-button-new" @click="clickGod"><span>神煞</span></button> -->
            </div>
        </div>
        <div v-if="fromPage == 'FamousPediaEdit' || fromPage == 'FamousPediaEditWeb' && curPediaEditType != 'check'" class="famous-pedia-title-side famous-pedia-title-side-right">
            <div class="famous-pedia-title-side-box-r">
                <button class="famous-pedia-title-button-new" @click="clickSaveEdit"><span v-bind:class="{'gray': !curPediaPipanInfoChanged}">保存修改</span></button>
                <button class="famous-pedia-title-button-new" @click="clickSubmit"><span>提交百科</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import { message } from '../../modules/api';
import { FAMOUS_DOM } from '../../modules/dom';
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
export default {
    name: 'FamousTitleBar',
    props: {
        titleName: {
            type: String,
            default() { return '' }            
        },
        fromPage: {
            type: String,
            default() { return '' }
        },
        inviteFunc: {
            type: Function,
            default() { return null }
        }
    },
    computed: {
        curPediaEditType() {
            return this.$store.state.famouspedia.curPediaEditType;
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        },
        curPediaBaziInfoToBZ() {
            return this.$store.state.famouspedia.curPediaBaziInfoToBZ;
        },
        curPediaBaziCollect() {
            return this.$store.state.famouspedia.curPediaBaziCollect;
        },
        curPediaPipanInfoChanged() {
            return this.$store.state.famouspedia.curPediaPipanInfoChanged;
        },
        curPediaBaziLike() {
            return this.$store.state.famouspedia.curPediaBaziLike;
        }
    },
    methods: {
        clickBack() {
            // 页面跳转
            if(this.fromPage == 'FamousPediaRead') {
                var curParams = this.$router.history.current.params,
                    newPage = curParams.frompage;
                    newPage = '/' + newPage.replace(/\_/g, '/');
                this.$router.replace(newPage);
            }else if(this.fromPage == 'FamousPediaEdit') {
                // 跳转到「我的百科」tab
                this.$router.replace('/famouspedia');
            }else if (this.fromPage == 'FamousPediaEditWeb') {
                var curParams = this.$router.history.current.params, 
                    fromPage = curParams ? curParams.frompage : '',
                    id = this.curPediaBaziInfo.id;
                // console.error('clickBack------', fromPage);
                if(fromPage == 'read') {
                    this.$router.replace('/famouspediareadweb/' + id + '/famouspedia')
                }else if(fromPage == 'create'){
                    this.$router.replace('/famouspediacreate');
                }else if(fromPage == 'list') {
                    this.$router.replace('/webhome');
                }
            }
            // 重置数据
            
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('search/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            FAMOUS_DOM.bindFamousFormScrollEvent(false);
        },
        clickGood() {
            var me = this;
            if(this.curPediaBaziLike) { return; }
            this.$store.dispatch('famouspedia/toggleLikeBaike', {
                sucCCb: function() {
                    me.$toast('点赞成功');
                }
            })
        },
        clickStar() {
            var me = this;
            this.$store.dispatch('famouspedia/toggleCollectBaike', {
                sucCCb: function() {
                    me.$toast('收藏成功');
                },
                sucUnCCb: function() {
                    me.$toast('取消收藏成功');
                }
            });
        },
        clickGod() {
            console.log('clickGod')
        },
        clickCreate() {
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate');
        },
        // 保存逻辑
        clickSave() {
            console.log('clickSave-------', this.curPediaBaziInfo, this.curPediaBaziInfoToBZ)
            this.$store.dispatch('famouspedia/checkCurFamousBaziSaveList')
        },
        // 编辑逻辑
        clickEdit() {
            var curTab = this.$store.state.famouspedia.curPediaContentTab;
            if(curTab == 1) {
                FAMOUS_DOM.updateFamousReadStoryScrollTop('');
            }else if(curTab == 2) {
                FAMOUS_DOM.updateFamousReadCommentScrollTop('');
            }
            this.$store.state.famouspedia.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.modify;
            var me = this;
            setTimeout(() => {
                me.$router.replace('/famouspediaedit');
                FAMOUS_DOM.bindFamousFormScrollEvent(false);
            }, 200);            
        },
        // 保存修改逻辑
        clickSaveEdit() {
            var curPediaPipanInfoChanged = this.$store.state.famouspedia.curPediaPipanInfoChanged;
            if(curPediaPipanInfoChanged) {
                this.$toast('保存修改成功');
            }
        },
        clickInvite() {
            if(this.inviteFunc && typeof(this.inviteFunc) == 'function') {
                this.inviteFunc();
            }
        },
        clickSubmit() {
            var me = this,
                curPediaEditType = this.$store.state.famouspedia.curPediaEditType,
                curPediaBaziInfo = this.$store.state.famouspedia.curPediaBaziInfo,
                curPediaPipanInfoChanged = this.$store.state.famouspedia.curPediaPipanInfoChanged,
                curPediaPipanModifyRemark = this.$store.state.famouspedia.curPediaPipanModifyRemark;
            console.log('clickSubmit------', curPediaEditType, curPediaPipanInfoChanged)
            // if(!curPediaPipanInfoChanged) {
            //     this.$toast('未检测到任何修改哟~');
            //     return;
            // }
            if(curPediaBaziInfo && curPediaBaziInfo.f_status == 3 && curPediaPipanModifyRemark == '') {
                this.$toast('请填写修改原因再提交哟~');
                return;
            }
            if(curPediaBaziInfo && curPediaBaziInfo.f_status == 3) {
                this.$store.dispatch('famouspedia/submitBaiKePipanCheck', {
                    sucCb: function() {
                        me.$toast('提交百科审核成功');
                        me.$router.replace('/famouspedia');
                    },
                    failCb: function(data) {
                        if(data.status_code){
                            me.$toast(message[data.status_code]);
                        }
                    }
                });
            }else {
                this.$store.dispatch('famouspedia/submitBaiKeCheck', {
                    sucCb: function() {
                        me.$toast('提交百科审核成功');
                        me.$router.replace('/famouspedia');
                    },
                    failCb: function(data) {
                        if(data.status_code){
                            me.$toast(message[data.status_code]);
                        }
                    }
                });
            }
        }
    }
}
</script>